export enum AccessLevel {
  Parent = 'Parent',
  Teacher = 'Teacher',
  SuperAdmin = 'SuperAdmin',
  UnitAdmin = 'UnitAdmin',
  Support = 'Support',
}
